<template>
  <div class="container" id="cont">
    <!-- Graphics - Prioritization & Detail -->
    <div>
      <!-- Menu -->
      <div class="columns">
        <div class="column is-one-third">
          <nav class="tabs is-boxed">
            <ul>
              <li
                v-bind:class="{ 'is-active': stepGraphic == 1 }"
                @click="changeTab(1)"
              >
                <a href="javascript:void(0)">Priorización</a>
              </li>
              <li
                v-bind:class="{ 'is-active': stepGraphic == 2 }"
                @click="changeTab(2)"
              >
                <a href="javascript:void(0)">Distribución</a>
              </li>
              <li
                v-if="tokenUser && tokenUser.admin"
                v-bind:class="{
                  'is-active': stepGraphic == 3,
                  disabled: validCtx,
                }"
                @click="!validCtx && changeTab(3)"
              >
                <a href="javascript:void(0)">Benchmark</a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="column">
          <!-- Title Distribution -->
          <div v-if="stepGraphic == 2" class="is-flex is-justify-center">
            <hr class="has-text-dark" style="width: 5%" />
            <h1 class="title is-size-4" style="margin: auto">
              Distribución de encuestados por niveles de calidad de clima
            </h1>
            <hr class="has-text-dark" style="width: 5%" />
          </div>
        </div>
      </div>
      <Transition name="fade">
        <!-- Prioritization -->
        <div v-if="stepGraphic == 1">
          <!-- Filters -->
          <div class="columns">
            <div class="column"></div>
            <div class="column is-8 is-flex">
              <div
                v-for="(v, k) in this.selected.filters"
                :key="k"
                class="control"
                style="margin-right: 5px;"
              >
                <div class="tags has-addons">
                  <span class="tag is-small is-dark">
                    {{ k }}
                  </span>
                  <span
                    v-for="(vG, kG) in v"
                    :key="kG + '' + vG"
                    class="tag is-small"
                  >
                    {{ vG }}
                  </span>
                </div>
              </div>
            </div>
            <div class="column"></div>
          </div>
          <!-- Main Results -->
          <div class="columns">
            <div class="column"></div>
            <div class="column is-8">
              <div class="has-text-centered is-size-3">
                <div
                  :class="
                    `rango${rangos(
                      summary.total ? summary.total.CClimad.p : 0
                    )} radius-6`
                  "
                >
                  <div
                    v-if="summary.total"
                    class="is-flex is-justify-center"
                    style="align-items: center;"
                  >
                    <h1 class="has-text-weight-bold" style="padding: 1.5rem;">
                      {{ nameResults() }}

                      <span>
                        {{
                          nombrerangos[
                            rangos(summary.total ? summary.total.CClimad.p : 0)
                          ]
                        }}
                      </span>
                      {{
                        summary.total
                          ? summary.total.CClimad.p
                          : 0 | number1(1)
                      }}%
                    </h1>
                    <direction-indicator
                      v-if="summary.processComp"
                      :w="30"
                      :h="30"
                      :summary="summary"
                      :nombrerangos="nombrerangos"
                      group="CClimad"
                      :rangos="rangos"
                    />
                  </div>
                </div>
              </div>
              <div
                class="is-flex is-justify-center is-size-5"
                v-if="
                  infoProcess.participationFilter ||
                    infoProcess.totalPartiFilter
                "
              >
                <div class="tags has-addons">
                  <span class="tag is-medium">
                    Participación: {{ infoProcess.participationFilter }}%
                  </span>
                  <span class="tag is-medium">
                    Encuestados: {{ infoProcess.totalPartiFilter }}
                  </span>
                </div>
              </div>
            </div>
            <div class="column">
              <div
                v-if="!this.$route.params.id"
                v-tooltip.left="'Link de tablero'"
                v-on:click="copyLink()"
              >
                <i
                  class="material-icons is-size-5 has-text-link"
                  style="margin-right: 5px; cursor: pointer"
                  >share</i
                >
              </div>
            </div>
          </div>
          <div
            id="graphsContent"
            class="columns is-gapless is-multiline"
            style="position: relative"
          >
            <div class="column is-12 is-hidden-mobil">
              <div class="has-text-centered is-size-4-desktop is-size-6-tablet">
                <h1>
                  Flexibilidad
                </h1>
              </div>
            </div>
            <div class="column is-6">
              <div class="notification bloquex1">
                <div class="control">
                  <div class="tags has-addons">
                    <span
                      class="tag is-medium tagName"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.apoyod.p : 0
                        )}`
                      "
                    >
                      Apoyo
                    </span>
                    <span
                      class="tag is-medium tagNumber"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.apoyod.p : 0
                        )}`
                      "
                    >
                      {{
                        summary.total ? summary.total.apoyod.p : 0 | number1(1)
                      }}%
                    </span>
                    <span
                      class="tag is-medium tagIcon"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.apoyod.p : 0
                        )}`
                      "
                      v-if="summary.processComp"
                    >
                      <direction-indicator
                        :w="25"
                        :h="25"
                        :summary="summary"
                        :nombrerangos="nombrerangos"
                        group="apoyod"
                        :rangos="rangos"
                      />
                    </span>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-8" v-if="summary">
                    <y-graph
                      :data="createGraph(['apsd', 'vincd', 'apod'], 'apoyod')"
                      :change="change"
                    ></y-graph>
                  </div>
                  <div class="column"></div>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="notification bloquex2">
                <div class="control">
                  <div class="tags has-addons is-right">
                    <span
                      class="tag is-medium tagName"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.innovaciond.p : 0
                        )}`
                      "
                    >
                      Innovación
                    </span>
                    <span
                      class="tag is-medium tagNumber"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.innovaciond.p : 0
                        )}`
                      "
                    >
                      {{
                        summary.total
                          ? summary.total.innovaciond.p
                          : 0 | number1(1)
                      }}%
                    </span>
                    <span
                      class="tag is-medium tagIcon"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.innovaciond.p : 0
                        )}`
                      "
                      v-if="summary.processComp"
                    >
                      <direction-indicator
                        :w="25"
                        :h="25"
                        :summary="summary"
                        :nombrerangos="nombrerangos"
                        group="innovaciond"
                        :rangos="rangos"
                      />
                    </span>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4"></div>
                  <div class="column is-8" v-if="summary">
                    <y-graph
                      :data="
                        createGraph(['autd', 'agid', 'mejd'], 'innovaciond')
                      "
                      :change="change"
                    ></y-graph>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div
                class="notification has-text-center bloquex5"
                style="width: 438px !important; height: 240px !important;"
              >
                <div class="has-text-centered is-fullwidth">
                  <strong>Dimensiones Centrales</strong>
                </div>
                <div v-if="summary">
                  <y-graph
                    :data="
                      createGraph(['lidd', 'engad', 'recd', 'compd'], 'dimenc')
                    "
                    :change="change"
                  ></y-graph>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="notification bloquex3">
                <div class="control">
                  <div class="tags has-addons">
                    <span
                      class="tag is-medium tagName"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.calidadd.p : 0
                        )}`
                      "
                    >
                      Calidad
                    </span>
                    <span
                      class="tag is-medium tagNumber"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.calidadd.p : 0
                        )}`
                      "
                    >
                      {{
                        summary.total
                          ? summary.total.calidadd.p
                          : 0 | number1(1)
                      }}%
                    </span>
                    <span
                      class="tag is-medium tagIcon"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.calidadd.p : 0
                        )}`
                      "
                      v-if="summary.processComp"
                    >
                      <direction-indicator
                        :w="25"
                        :h="25"
                        :summary="summary"
                        :nombrerangos="nombrerangos"
                        group="calidadd"
                        :rangos="rangos"
                      />
                    </span>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-8" v-if="summary">
                    <y-graph
                      :data="createGraph(['excd', 'cycd', 'segd'], 'calidadd')"
                      :change="change"
                    ></y-graph>
                  </div>
                  <div class="column is-4"></div>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="notification bloquex4">
                <div class="control">
                  <div class="tags has-addons is-8 is-right">
                    <span
                      class="tag is-medium tagName"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.metasd.p : 0
                        )}`
                      "
                    >
                      Metas
                    </span>
                    <span
                      class="tag is-medium tagNumber"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.metasd.p : 0
                        )}`
                      "
                    >
                      {{
                        summary.total ? summary.total.metasd.p : 0 | number1(1)
                      }}%
                    </span>
                    <span
                      class="tag is-medium tagIcon"
                      :class="
                        `rango${rangos(
                          summary.total ? summary.total.metasd.p : 0
                        )}`
                      "
                      v-if="summary.processComp"
                    >
                      <direction-indicator
                        :w="25"
                        :h="25"
                        :summary="summary"
                        :nombrerangos="nombrerangos"
                        group="metasd"
                        :rangos="rangos"
                      />
                    </span>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4"></div>
                  <div class="column is-8" v-if="summary">
                    <y-graph
                      :data="createGraph(['logrd', 'servd', 'repd'], 'metasd')"
                      :change="change"
                    ></y-graph>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 is-hidden-mobile">
              <div class="has-text-centered is-size-4-desktop is-size-6-tablet">
                <h1>
                  Consistencia
                </h1>
              </div>
            </div>
            <!--    Titles Left and Right   -->
            <div class="column is-12 is-hidden-mobile">
              <div
                class="has-text-left is-size-5-desktop is-size-6-tablet titleLeft"
              >
                <h1>
                  Foco Interno
                </h1>
              </div>
            </div>
            <div class="column is-12 is-hidden-mobile">
              <div
                class="has-text-left is-size-5-desktop is-size-6-tablet titleRight"
              >
                <h1>
                  Foco Externo
                </h1>
              </div>
            </div>
          </div>
        </div>
      </Transition>
      <Transition name="fade">
        <!-- Detail -->
        <div v-if="stepGraphic == 2" style="margin-top: 15px;">
          <div v-for="(v, k) in detailData" :key="k">
            <GraphDetailResult
              :group="null"
              :var="k"
              :title="k === 'CClimad' ? nameResults() : namevars[k]"
              :change="change"
              :data="summary.total[k]"
              :dataTarget="
                summary.processComp ? summary.processComp.total[k] : null
              "
              :items="false"
              :ranges="rangos"
              @switchSubGroups="switchSubGroups"
            />
            <div v-for="(v1, k1) in v" :key="k1">
              <GraphDetailResult
                :group="null"
                :var="k1"
                :title="namevars[k1]"
                :change="change"
                :data="summary.total[k1]"
                :dataTarget="
                  summary.processComp ? summary.processComp.total[k1] : null
                "
                :items="true"
                :active="v1.active"
                :ranges="rangos"
                @switchSubGroups="switchSubGroups"
                @openMenuInter="openMenuInter"
              />
              <!-- Whit Switch -->
              <article v-if="v1 && v1.active && !v1.unique" class="message">
                <div class="message-body">
                  <div v-for="(v2, k2) in v1.data" :key="k2">
                    <GraphDetailResult
                      :group="k1"
                      :var="v2"
                      :title="namevars[v2]"
                      :change="change"
                      :data="summary.total[v2]"
                      :dataTarget="
                        summary.processComp
                          ? summary.processComp.total[v2]
                          : null
                      "
                      :items="false"
                      :ranges="rangos"
                      @switchSubGroups="switchSubGroups"
                      @openMenuInter="openMenuInter"
                    />
                  </div>
                </div>
              </article>
              <!-- Not Switch -->
              <div v-if="v1 && v1.data && v1.unique">
                <div v-for="(v2, k2) in v1.data" :key="k2">
                  <GraphDetailResult
                    :group="k1"
                    :var="v2"
                    :title="namevars[v2]"
                    :change="change"
                    :data="summary.total[v2]"
                    :dataTarget="
                      summary.processComp ? summary.processComp.total[v2] : null
                    "
                    :active="false"
                    :ranges="rangos"
                    @switchSubGroups="switchSubGroups"
                    @openMenuInter="openMenuInter"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Transition>
      <Transition name="fade">
        <!-- General Ctx -->
        <div v-if="stepGraphic == 3" style="margin-top: 15px;">
          <div v-for="(v, k) in detailData" :key="k">
            <GraphCtxResult
              :group="null"
              :var="k"
              :title="k === 'CClimad' ? nameResults() : namevars[k]"
              :change="change"
              :data="summary.total[k]"
              :dataTarget="
                summary.processComp ? summary.processComp.total[k] : null
              "
              :generalContext="generalContext"
              :items="false"
              :ranges="rangos"
              @switchSubGroups="switchSubGroups"
            />
            <div v-for="(v1, k1) in v" :key="k1">
              <GraphCtxResult
                :group="null"
                :var="k1"
                :title="namevars[k1]"
                :change="change"
                :data="summary.total[k1]"
                :dataTarget="
                  summary.processComp ? summary.processComp.total[k1] : null
                "
                :generalContext="generalContext"
                :items="true"
                :active="v1.active"
                :ranges="rangos"
                @switchSubGroups="switchSubGroups"
                @openMenuInter="openMenuInter"
              />
              <!-- Whit Switch -->
              <article v-if="v1 && v1.active && !v1.unique" class="message">
                <div class="message-body">
                  <div v-for="(v2, k2) in v1.data" :key="k2">
                    <GraphCtxResult
                      :group="k1"
                      :var="v2"
                      :title="namevars[v2]"
                      :change="change"
                      :data="summary.total[v2]"
                      :dataTarget="
                        summary.processComp
                          ? summary.processComp.total[v2]
                          : null
                      "
                      :generalContext="generalContext"
                      :items="false"
                      :ranges="rangos"
                      @switchSubGroups="switchSubGroups"
                      @openMenuInter="openMenuInter"
                    />
                  </div>
                </div>
              </article>
              <!-- Not Switch -->
              <div v-if="v1 && v1.data && v1.unique">
                <div v-for="(v2, k2) in v1.data" :key="k2">
                  <GraphCtxResult
                    :group="k1"
                    :var="v2"
                    :title="namevars[v2]"
                    :change="change"
                    :data="summary.total[v2]"
                    :dataTarget="
                      summary.processComp ? summary.processComp.total[v2] : null
                    "
                    :generalContext="generalContext"
                    :active="false"
                    :ranges="rangos"
                    @switchSubGroups="switchSubGroups"
                    @openMenuInter="openMenuInter"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </div>
    <!-- Table Groups -->
    <div
      v-if="!this.$route.params.id && groups.length"
      style="margin-top: 50px"
      class="is-flex is-justify-center"
    >
      <hr class="has-text-dark" style="width: 20%" />
      <h1
        class="title is-size-4"
        style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
      >
        Prioridad de Intervención en subgrupos
      </h1>
      <hr class="has-text-dark" style="width: 20%" />
    </div>
    <div v-if="!this.$route.params.id">
      <table-groups
        ref="tableClima"
        v-if="groups.length"
        :get-range="rangos"
        :datos="groups"
        :limitSelection="groups.length"
        :nameQuadrants="namevars"
        :nameRanges="nombrerangos"
        @setFilterTable="setFilterTable"
        @copyLink="copyLink"
      ></table-groups>
    </div>
    <!-- Buttons -->
    <div
      v-if="!this.$route.params.id"
      v-on:click="section"
      class="button is-dark"
      style="margin-top: 50px; margin-right: 10px"
    >
      <span style="margin-right: 5px">{{
        showSection ? "Ver menos Detalles" : "Ver Detalles"
      }}</span>
      <span class="icon"
        ><i class="material-icons is-size-1">{{
          showSection ? "arrow_drop_up" : "arrow_drop_down"
        }}</i></span
      >
    </div>
    <div v-on:click="goToGuie" class="button is-dark" style="margin-top: 50px;">
      <span style="margin-right: 5px">Ver guía</span>
      <span class="icon"><i class="material-icons">local_library</i></span>
    </div>
    <!-- Comments -->
    <div
      v-if="!this.$route.params.id && comments.length > 5"
      style="margin-top: 60px !important"
    >
      <div style="margin-bottom: 40px;" class="is-flex is-justify-center">
        <hr class="has-text-dark" style="width: 20%" />
        <h1
          class="title is-size-4"
          style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
        >
          Comentarios
        </h1>
        <hr class="has-text-dark" style="width: 20%" />
      </div>
      <br />
      <div
        style="height: 330px !important; overflow-y: scroll;"
        class="container"
      >
        <div class="box">
          <div v-for="(c, index) in comments" :key="index">
            <div>
              <div v-if="c.responses.comentarios">
                <article class="media" style="padding-bottom: 15px">
                  <figure class="media-left">
                    <p class="image">
                      <i class="material-icons is-size-1">account_box</i>
                    </p>
                  </figure>
                  <div class="media-content">
                    <div class="content">
                      <p>
                        <strong>Anónimo</strong>
                        <br />
                        {{ c ? c.responses.comentarios : "" }}
                      </p>
                    </div>
                    <!-- <nav class="level is-mobile">
                      <div class="level-left">
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-reply"></i></span>
                        </a>
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                        </a>
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-heart"></i></span>
                        </a>
                      </div>
                    </nav> -->
                  </div>
                </article>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <menu-interpretacion
      v-if="menuInter.showInter"
      :data="menuInter.data"
      :type="menuInter.type"
      @closeMenuInter="closeMenuInter"
    ></menu-interpretacion>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import tableGroups from "./TableGroups.vue";
import directionIndicator from "./components/directionIndicator.vue";
import menuInterpretacion from "./components/menuInterpretacion.vue";
import yGraph from "../dashboard/GraphApexChart.vue";
import { mapState } from "vuex";
import json from "./interpretaciones.json";
import GraphDetailResult from "./components/graphDetailResult.vue";
import GraphCtxResult from "./components/graphCtxResult.vue";

export default {
  data() {
    return {
      loader: false,
      widthdiv: 0,
      namevars: {
        apsd: "Social",
        vincd: "Compromiso",
        apod: "Organizacional",
        autd: "Autonomía",
        agid: "Agilidad",
        mejd: "Mejora",
        excd: "Excelencia",
        cycd: "C. y Claridad",
        segd: "Seguridad",
        logrd: "Logro",
        servd: "Servicio",
        repd: "Reputación",
        lidd: "Liderazgo",
        engad: "Engagement",
        recd: "Recursos",
        compd: "Compensación",
        CClimad: "Toda la Organización",
        dimenc: "Dimensiones Centrales",
        apoyod: "Apoyo",
        innovaciond: "Innovación",
        calidadd: "Calidad",
        metasd: "Metas",
      },
      nombrerangos: {
        1: "Sigamos así",
        2: "Vamos bien",
        3: "Cuidado",
        4: "Necesita atención pronto",
        5: "Actuemos ya",
        0: "N/A",
      },
      calificaciones: json,
      comments: {},
      summary: {},
      detailSummary: {
        CClimad: {
          apoyod: {
            data: ["apsd", "vincd", "apod"],
            active: false,
          },
          innovaciond: {
            data: ["autd", "agid", "mejd"],
            active: false,
          },
          calidadd: {
            data: ["excd", "cycd", "segd"],
            active: false,
          },
          metasd: {
            data: ["logrd", "servd", "repd"],
            active: false,
          },
          dimenc: {
            data: ["lidd", "engad", "recd", "compd"],
            active: false,
            unique: true,
          },
        },
      },
      groups: [],
      infoProcess: {},
      selected: {
        filters: {},
      },
      change: 0,
      menuInter: {
        showInter: false,
        data: null,
        type: 0,
      },
      stepGraphic: 1,
    };
  },
  computed: {
    ...mapState(["windowwidth", "isOculto", "empresa", "tokenUser"]),
    detailData() {
      return this.detailSummary;
    },
  },
  props: {
    proceso: {
      type: Object,
    },
    showSection: Boolean,
    processValuesCal: {
      type: Function,
      required: true,
    },
    summaryTotal: {
      type: Object,
      required: true,
    },
    generalContext: {
      type: Object,
      required: true,
    },
    validCtx: {
      type: Boolean,
      required: true,
    },
  },
  beforeMount() {
    this.configSummary();
    // console.log("summary", this.summary);
  },
  methods: {
    async findSummary() {
      try {
        const query = {
          filters: this.selected.filters,
          proceso: this.proceso._id,
        };
        let result = await apiServices.post(`/traecalculoclima`, query);
        if (result.data) {
          if (this.proceso.processComp) {
            const resultComp = await apiServices.post(`/traecalculoclima`, {
              filters: this.selected.filters,
              proceso: this.proceso.processComp._id,
            });
            result.data.calculos.processComp = this.processValuesCal(
              resultComp.data.calculos
            );
            result.data.calculos.processComp.nombre = this.proceso.processComp.nombre;
          }
          this.infoProcess = result.data.infoProcess;
          this.summary = this.processValuesCal(result.data.calculos);
          this.change = this.change ? 0 : 1;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      const result = await apiServices.post(`/traegruposclima`, {
        proceso: this.proceso._id,
      });
      this.groups = result.data;
    },
    async findComments() {
      try {
        const result = await apiServices.post(
          `/listcommentsclima/${this.proceso._id}`,
          { filter: this.selected.filters }
        );
        if (result.data.length > 4) {
          this.comments = result.data;
        } else {
          this.comments = {};
        }
      } catch (err) {
        console.log(err);
      }
    },
    configSummary() {
      this.summary = this.summaryTotal;
      if (this.summaryTotal.filters) {
        this.selected.filters = this.summaryTotal.filters;
      }
      if (this.summaryTotal.infoProcess) {
        this.infoProcess = this.summaryTotal.infoProcess;
      }
    },
    // Graficas
    createGraph(labels, group) {
      if (this.summary && labels) {
        const colors = [
          "#a5a5a5",
          "#76be7c",
          "#d9ead3",
          "#fde8af",
          "#f5bc95",
          "#fda0a0",
        ];
        let dataSummary = this.summary;
        labels = labels.filter((x) =>
          Object.keys(dataSummary.total).includes(x)
        );
        let graph = {
          series: [
            {
              name: "Actual",
              data: [
                {
                  x: "Datos",
                  y: 12,
                  goals: [
                    {
                      name: "Anterior",
                      value: 14,
                      strokeWidth: 2,
                      strokeDashArray: 2,
                      strokeColor: "#775DD0",
                    },
                  ],
                },
              ],
            },
          ],
          options: {
            chart: {
              width: "100%",
              height: "100%",
              redrawOnParentResize: true,
              redrawOnWindowResize: false,
              type: "bar",
              toolbar: {
                show: false,
              },
              events: {
                click: (event, chartContext, w) =>
                  this.openMenuInter({ ...w, type: 0 }),
              },
            },
            plotOptions: {
              bar: {
                distributed: true,
                horizontal: true,
                borderRadius: 4,
                colors: {
                  backgroundBarColors: ["#f9f8f8"],
                },
              },
            },
            states: {
              normal: {
                filter: {
                  type: "none", // No aplica ningún filtro cuando está en estado normal
                },
              },
              active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                  type: "none", // No aplica ningún filtro cuando está en estado activo (seleccionado)
                },
              },
            },
            colors: [],
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              enabled: true,
              custom: ({ series, seriesIndex, dataPointIndex, w }) =>
                this.tooltipBar({ series, seriesIndex, dataPointIndex, w }),
              shared: true,
              intersect: false,
              followCursor: true,
              items: {
                display: "flex",
              },
            },
            legend: {
              show: false,
            },
            xaxis: {
              min: 0,
              max: 100,
            },
          },
          width: "370",
          height: "185",
          type: "bar",
        };

        // Custom barHeight for group dimenc
        if (group === "dimenc") {
          graph.options.plotOptions.bar.barHeight = "20.5359";
        }

        graph.series[0].data = labels.map((x) => {
          const v = dataSummary.total[x].p;
          const vComp = dataSummary.processComp
            ? dataSummary.processComp.total[x].p
            : 0;
          const d = {
            x: this.namevars[x],
            key: x,
            y: v.toFixed(1),
            group,
          };

          if (dataSummary.processComp && vComp) {
            d.goals = [
              {
                name: "Anterior",
                value: vComp.toFixed(1),
                strokeWidth: 2,
                strokeDashArray: 2,
                strokeColor: "#000000",
              },
            ];
          }

          graph.options.colors.push(colors[this.rangos(v)]);
          return d;
        });
        return graph;
      }
    },
    tooltipBar({ series, seriesIndex, dataPointIndex, w }) {
      const data = {
        group: w.config.series[0].data[dataPointIndex].group,
        dim: w.config.series[0].data[dataPointIndex].key,
        dataValue: w.config.series[0].data[dataPointIndex].y.replace(".", ","),
        valueColor: w.config.colors[dataPointIndex],
        dataTarget: w.config.series[0].data[dataPointIndex].goals
          ? w.config.series[0].data[dataPointIndex].goals[0].value
          : 0,
        targetColor: w.config.series[0].data[dataPointIndex].goals
          ? w.config.series[0].data[dataPointIndex].goals[0].strokeColor
          : 0,
      };
      data.title = this.calificaciones[data.group]["dimensiones"][
        data.dim
      ].title;
      data.def = this.calificaciones[data.group]["dimensiones"][data.dim].def;
      const labelTarget = w.config.series[0].data[dataPointIndex].goals
        ? "<div style='display: flex;'>" +
          `<div style='width: 15px; border: 1px solid darkgray; height: 15px; background: ${data.targetColor}; margin-right: 5px'></div>` +
          "<strong class='has-text-white' style='margin-right: 5px'>Anterior</strong>" +
          data.dataTarget +
          "%" +
          "</div>"
        : "";

      return `<div>
        <strong style="color: white; font-size: 15px;">${data.title}</strong>
        <br>
        <div style='display: flex;'>
          <div style='width: 15px; border: 1px solid darkgray; height: 12px; background: ${data.valueColor}; margin-right: 5px'></div>
          <strong class='has-text-white' style='margin-right: 5px'>Actual</strong>
          ${data.dataValue}%
        </div>
        ${labelTarget}
        <br>
        <div>
            <strong style="color: white; font-size: 15px;">Definición</strong>
            <p>
                ${data.def}
            </p>
        </div>
        <br>
        <span class='is-size-7 has-text-weight-bold'>Clic para ver más.</span>
      </div>`;
    },
    openMenuInter(w) {
      this.menuInter.data = w;
      this.menuInter.type = w.type;
      this.menuInter.showInter = true;
    },
    closeMenuInter() {
      this.menuInter.showInter = false;
    },
    // filtro
    setFilterTable(data) {
      if (data.length) {
        const filters = {};
        data.map((x) => {
          const g = x.group;
          const sg = x.name;
          if (filters[g]) {
            filters[g].push(sg);
          } else {
            filters[g] = [sg];
          }
        });
        this.selected.filters = filters;
      } else {
        this.selected.filters = {};
      }
    },
    deselectFilter() {
      this.$refs.tableClima.deselect();
    },
    deselectOne(filter) {
      // Validar si será necesario utilizarlo y organizarlo
      this.$refs.tableClima.deselectOne([filter]);
    },
    // Others
    async copyLink(filter = null) {
      let textArea = document.createElement("textarea");

      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = "2em";
      textArea.style.height = "2em";

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = "transparent";

      let data = {};
      const allFilters = this.selected.filters;
      filter = filter ? JSON.stringify(filter) : JSON.stringify(allFilters);

      const encodeFilter = btoa(filter); // Para descifrarlo es con atob()

      data.process = this.proceso._id;
      data.filter = btoa(encodeFilter); // Se vuelve a cifrar

      textArea.value =
        window.location.host +
        "/shareClima/" +
        data.process +
        "/" +
        data.filter;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        let successful = document.execCommand("copy");
        let msg = successful ? "¡Copiado al portapapeles!" : "Error al copiar";
        let type = successful ? "is-link" : "is-danger";

        this.$store.dispatch("notify", {
          message: msg,
          type: type,
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Error al copiar",
          type: "is-danger",
        });
      }
      document.body.removeChild(textArea);
    },
    nameResults() {
      let texto = "Toda la organización";
      if (Object.keys(this.selected.filters).length === 1) {
        if (
          this.selected.filters[Object.keys(this.selected.filters)[0]].length >
          1
        ) {
          let grupo = Object.keys(this.selected.filters);
          texto = "Varios filtros de " + grupo;
        } else {
          let grupo = Object.keys(this.selected.filters);
          let subrupo = this.selected.filters[
            Object.keys(this.selected.filters)
          ][0];
          texto = grupo + " " + subrupo;
        }
      } else if (Object.keys(this.selected.filters).length > 1) {
        texto = "Varios filtros aplicados";
      }
      return texto;
    },
    changeTab(value) {
      this.stepGraphic = value;
    },
    section() {
      this.$emit("section");
    },
    goToGuie() {
      this.$emit("goToGuie");
    },
    calculaanchodediv() {
      this.widthdiv = document.getElementById("cont").clientWidth;
    },
    switchSubGroups(g) {
      this.detailSummary.CClimad[g].active = !this.detailSummary.CClimad[g]
        .active;
    },
    rangos(n) {
      let returned;
      if (n === 0) {
        returned = 5;
      } else if (isNaN(n)) {
        returned = 0;
      } else if (n >= 84) {
        // Mayor o igual a 84
        returned = 1;
      } else if (n >= 70 && n <= 83.9) {
        // Mayor o igual a 70 y Menor o igual 83.9
        returned = 2;
      } else if (n >= 30 && n <= 69.9) {
        // Mayor o igual a 30 y Menor o igual 69.9
        returned = 3;
      } else if (n >= 16 && n <= 29.9) {
        // Mayor o igual a 16 y Menor o igual 29.9
        returned = 4;
      } else {
        returned = 5;
      }
      return returned;
    },
  },
  mounted() {
    this.calculaanchodediv();
  },
  async created() {
    await this.getGroups();
    await this.findComments();
  },
  watch: {
    windowwidth(nv, ov) {
      this.calculaanchodediv();
    },
    "selected.filters": {
      deep: true,
      handler: function(nv) {
        // NOT consult if the route get of param id
        if (!this.$route.params.id) {
          if (Object.keys(nv).length) {
            this.findSummary();
            this.findComments();
          } else {
            this.summary = this.summaryTotal;
            this.change = this.change ? 0 : 1;
            this.infoProcess = {};
            this.findComments();
          }
        }
      },
    },
  },
  components: {
    yGraph,
    directionIndicator,
    tableGroups,
    menuInterpretacion,
    GraphDetailResult,
    GraphCtxResult,
  },
  errorCaptured(err, vm, info) {
    console.log({ err, vm, info });
    /* this.$store.dispatch("notify", {
      message: `Hubo un error al cargar el Tablero, intenta de nuevo o reporta este error`,
      type: "is-danger",
    }); */
  },
};
</script>

<style lang="scss" scoped>
/* Tags */

.tagName {
  width: 110px;
}
.tagNumber {
  width: 70px;
}

.tagIcon {
  width: 25px;
  padding-left: 15px !important;
}

.div-table {
  @media (min-width: 769px) {
    overflow-y: hidden !important;
  }
  @media (max-width: 768px) {
    overflow-x: scroll !important;
    overflow-y: scroll !important;
  }
}

.options {
  background-color: white;
  box-shadow: 0px 6px 28px -18px black;
  position: absolute;
  width: 57.5%;
  z-index: 35;
}

/* Table */

.heat-table {
  border: 1px solid #c2c2c2;
}

.heat-table thead {
  border: 1px solid #dbdbdb;
}

.heat-table tbody {
  border: 1px solid #dbdbdb;
}

.heat-table th {
  border: 1px solid #dbdbdb;
}

.heat-table td {
  border: 1px solid #dbdbdb;
}

.scroll-table {
  height: 306px;
  overflow-y: auto;
  overflow-x: auto;
}

.head-stick th {
  background: white;
  position: sticky;
  top: -3px; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  z-index: 60 !important;
}

.bloque1 {
  background-color: #76be7c;
  box-shadow: 2px 2px 4px 1px rgba(0, 0, 0, 0.2);
}

.bloque2 {
  background-color: #e9e9e9;
  border-style: solid;
  border-color: #c2c2c2;
}

.bloque3 {
  border-width: 5px;
  border-style: solid;
  border-color: #fae900;
}

.bloque4 {
  border-width: 5px;
  border-style: solid;
  border-color: #ff226b;
}

.bloque0 {
  border-width: 5px;
  border-style: solid;
  border-color: #a5a5a5;
}

.bloquex1 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 2px 1px 1px 2px;
  border-radius: 2px 0 0 0;
  border-color: #c2c2c2;
}

.bloquex2 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 2px 2px 1px 1px;
  border-radius: 0 2px 0 0;
  border-color: #c2c2c2;
}

.bloquex3 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 1px 1px 2px 2px;
  border-radius: 0 0 0 2px;
  border-color: #c2c2c2;
}

.bloquex4 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 1px 2px 2px 1px;
  border-radius: 0 0 2px 0;
  border-color: #c2c2c2;
}

.bloquex5 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 2px;
  border-radius: 2px;
  border-color: #c2c2c2;
  @media (min-width: 769px) {
    z-index: 2 !important;
    width: auto !important;
    height: 230px !important;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
  }
}

.titleLeft {
  position: absolute;
  z-index: 2;
  top: 47.5%;
  background: white;
  margin-left: 40px;
}

.titleRight {
  position: absolute;
  z-index: 2;
  top: 47.5%;
  background: white;
  left: 87%;
}

.tooltipCustom {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  //pointer-events: none;
  padding: 10px;
  font-size: 12px;
  min-width: 260px;
  max-width: 360px;
  max-height: 310px !important;
  overflow-y: scroll !important;
  z-index: 9999;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: none;
  opacity: 0;
}

// Tab

.tabs ul {
  border-bottom-width: 0 !important;
}

.tabs.is-boxed li {
  border-bottom-color: #dbdbdb;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.tabs.is-boxed li a {
  border-color: #dbdbdb !important;
}

.tabs.is-boxed li.is-active a {
  background-color: #522687;
  border-color: #905fbf;
  color: white;
  z-index: 1;
}

.tabs.is-boxed li.disabled {
  background-color: #dbdbdb;
  pointer-events: none;
  opacity: 0.6;
}
</style>
<style>
.apexcharts-tooltip {
  /* pointer-events: auto !important; */
  background: rgba(0, 0, 0, 0.7) !important;
  color: white !important;
  border-radius: 3px !important;
  padding: 10px !important;
  font-size: 12px !important;
  width: auto !important;
  min-width: 260px !important;
  max-width: 360px !important;
  height: auto !important;
  overflow-y: scroll !important;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif !important;
  white-space: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/ResultadosDetallado.vue